{
  "title": "如何上傳學生資格驗證的在學證明",
  "description": "在「學生資格驗證」頁面上傳、查看與重新上傳在學證明。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作路徑",
    "操作步驟",
    "完成後",
    "常見問題"
  ],
  "summary": "完成後，你的在學證明會送出等待主辦方人工審核，審核結果會顯示在同一頁。",
  "roleNote": "學生／參賽者",
  "prerequisites": [
    "已登入，且該競賽的主辦方已開啟「學生資格驗證」政策",
    "已備妥可上傳的在學證明檔案（在學證明書、學生證或其他經主辦方核准之文件）",
    "檔案格式為 PDF、PNG、JPG 或 JPEG，單一檔案大小不超過 10 MB"
  ],
  "pathLabel": "競賽工作區 → 參賽資訊 → 學生資格驗證",
  "steps": [
    {
      "title": "1. 開啟「學生資格驗證」頁面",
      "description": "若該場競賽要求學生資格驗證，競賽工作區的「參賽資訊」摘要區塊會顯示團隊資格驗證完成度磚（例如「1 / 2 位必要成員已完成資格驗證」），點擊即可進入獨立的「學生資格驗證」頁面。"
    },
    {
      "title": "2. 選擇證明類型並填寫基本資料",
      "description": "選擇證明類型（在學證明書、學生證或其他經核准之證明；若該競賽只接受單一類型則不會顯示此選項），填寫學校名稱；系所與學號為選填欄位，不填也可以送出。"
    },
    {
      "title": "3. 上傳檔案",
      "description": "選擇檔案並送出。系統會立即檢查檔案類型與大小是否符合限制，成功送出後畫面上的「我的資格驗證狀態」會變成「審核中」。"
    }
  ],
  "afterward": [
    "「我的資格驗證狀態」顯示為「審核中」",
    "已上傳的檔案可點擊「下載檢視」確認上傳內容是否正確",
    "主辦方（該場競賽的競賽管理員）完成人工審核後，狀態會更新為「已驗證」或「已退回」（連同退回原因一併顯示）；系統不會自動通過"
  ],
  "nextSteps": "若證明被退回，請見「資格證明被退回怎麼辦」了解如何重新上傳。",
  "warning": "資格驗證狀態不會影響你的報名是否已經完成：即使目前顯示「尚未上傳」「審核中」「已退回」或「已過期」，只要報名表單的必填欄位都已填妥並點擊「確認並完成報名」，你的報名就是已完成狀態，儲存報名資料的動作永遠不會檢查資格驗證結果。",
  "faq": [
    {
      "q": "審核中還可以重新上傳嗎？",
      "a": "可以。在「我的資格驗證狀態」卡片下方點擊「重新上傳」展開表單，系統會自動帶入你目前的證明類型、學校、系所、學號，不需要重新輸入一次；只換檔案或連同資料一併修改都可以。若中途不想繼續，點擊「取消」即可收合表單，不會影響原本已送出、正在審核中的證明。"
    },
    {
      "q": "隊友看得到我上傳的證明內容嗎？",
      "a": "看不到。你上傳的原始證明檔案只有你本人與該場競賽具審核權限的主辦方看得到；隊友只會在「團隊資格驗證完成度」看到你的狀態標籤（例如已驗證、審核中），看不到證明檔案或退回原因。"
    },
    {
      "q": "上傳的證明檔案會保存多久？",
      "a": "依平台的資料保存政策，原始證明檔案會在該場競賽結束滿 365 天後自動永久刪除，僅保留審核結果（通過／未通過與時間）供日後查核，檔案本身無法復原。"
    }
  ]
}
